import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Table } from 'react-bootstrap'
import API from '../../utils/API'
import { ABSpinner, useErrorService, useUserService } from '@abroad/components'
import { convertSessionDate } from '../../utils/date'
import { DeleteConfirmationPrompt } from '../common/DeleteConfirmationPrompt'

const CoachingPlanSession = ({ sowId }) => {
  const [sessionData, setSessionData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)
  const [sessionToDelete, setSessionToDelete] = useState(null)
  const Error = useErrorService()
  const { user } = useUserService()

  useEffect(() => {
    const fetchCoachingPlanSession = async () => {
      if (!sowId) {
        setIsLoading(false)
        return
      }

      try {
        setIsLoading(true)
        const { data } = await API.AdminAPI.coachPlan.getcoachingPlansession(
          sowId,
        )
        setSessionData(data)
      } catch (err) {
        Error.showError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchCoachingPlanSession()
  }, [sowId])

  if (isLoading) {
    return <ABSpinner />
  }

  const sessions = sessionData?.sessions || []

  const deleteSession = async () => {
    if (!sessionToDelete) return
    setIsDeleteLoading(true)
    try {
      await API.CoachAPI.coachingSession.deleteSession(
        sessionToDelete._id,
        sessionToDelete.clientId,
      )
      // Refresh session list after delete
      const { data } = await API.AdminAPI.coachPlan.getcoachingPlansession(
        sowId,
      )
      setSessionData(data)
      setShowModal(false)
      setSessionToDelete(null)
    } catch (err) {
      Error.showError(err)
    } finally {
      setIsDeleteLoading(false)
    }
  }

  return (
    <div className='coaching-plan-sessions'>
      {!isLoading && (
        <Container className='px-0' fluid>
          <Row className='m-0 d-lg-block'>
            <div className='col-xs-12'>
              <div>
                <Table hover responsive className='custom-table'>
                  <thead>
                    <tr>
                      <th width='24%'>Date</th>
                      <th width='19%' className='text-center'>
                        Type
                      </th>
                      <th width='19%' className='text-center'>
                        Coach
                      </th>
                      <th width='19%' className='text-center'>
                        Duration
                      </th>
                      {user?.isAdmin && (
                        <th width='19%' className='text-center'>
                          Actions
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {sessions.length > 0 ? (
                      sessions.map((session, index) => (
                        <tr key={session._id || index}>
                          <td>
                            <Link
                              className='text-dark-900 font-bold cursor-pointer'
                              to={
                                session.isGrowthSession
                                  ? {
                                      pathname: `/coach/clients/${session.clientId}/growth-plan/${session.planId}/${session._id}/view`,
                                      state: {
                                        isEditable:
                                          session.coachId?._id === user?._id,
                                      },
                                    }
                                  : `/coach/clients/${session.clientId}/session/${session._id}`
                              }>
                              {convertSessionDate(session.date, 'MM/DD/YY')}
                            </Link>
                          </td>
                          <td className='text-center'>
                            <span>
                              {session.isGrowthSession ? 'Growth' : 'Regular'}
                            </span>
                          </td>
                          <td className='text-center'>
                            <span>{session.coachId?.fullName || '-'}</span>
                          </td>
                          <td className='text-center'>
                            <span>{`${session.length} mins`}</span>
                          </td>
                          {user?.isAdmin && (
                            <td className='text-center'>
                              <span
                                className='delete-link cursor-pointer'
                                onClick={() => {
                                  setSessionToDelete(session)
                                  setShowModal(true)
                                }}>
                                Delete
                              </span>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan='5' className='text-center font-montserrat'>
                          No Sessions Found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </Row>
        </Container>
      )}
      <DeleteConfirmationPrompt
        showModal={showModal}
        setShowModal={setShowModal}
        isDeleteLoading={isDeleteLoading}
        handleDelete={deleteSession}
        message='This cannot be reverted. Are you sure you want to delete this session?'
      />
    </div>
  )
}

export default CoachingPlanSession
